import { combineReducers } from 'redux';
import { routerReducer, RouterState } from 'react-router-redux';
//#region import /container/api/** */
//#region import /container/api/stat/** */
import DegerlemeToplamDegerR from './container/api/stat/DegerlemeToplamDegerReducer';
import GayrimenkulAlanApiR from './container/api/stat/GayrimenkulAlanReducer';
import GayrimenkulSayiApiR from './container/api/stat/GayrimenkulSayiReducer';
import GayrimenkulToplamDegerApiR from './container/api/stat/GayrimenkulToplamDegerReducer';
import KullanimAmacliGayrimenkulAlanR from './container/api/stat/KullanimAmacliGayrimenkulAlanReducer';
import KullanimAmacliGayrimenkulSayiR from './container/api/stat/KullanimAmacliGayrimenkulSayiReducer';
import KullanimAmacliGayrimenkulToplamDegerR from './container/api/stat/KullanimAmacliGayrimenkulToplamDegerReducer';
import OyakDegerlemeToplamDegerR from './container/api/stat/OyakDegerlemeToplamDegerReducer';
import OyakEmlakVergileriR from './container/api/stat/OyakEmlakVergileriReducer';
import OyakEmlakVergileriDetayToplamDegerR from './container/api/stat/OyakEmlakVergileriDetayToplamDegerReducer';
import OyakKiraTrGeneliAylikGelirDagilimiListeleR from './container/api/stat/OyakKiraTrGeneliAylikGelirDagilimiListeleReducer';
import OyakKiraTrGeneliYillikGelirDagilimiListeleR from './container/api/stat/OyakKiraTrGeneliYillikGelirDagilimiListeleReducer';
import YatirimAmacliGayrimenkulAlanR from './container/api/stat/YatirimAmacliGayrimenkulAlanReducer';
import YatirimAmacliGayrimenkulSayiR from './container/api/stat/YatirimAmacliGayrimenkulSayiReducer';
import YatirimAmacliGayrimenkulToplamDegerR from './container/api/stat/YatirimAmacliGayrimenkulToplamDegerReducer';
//#endregion
//#region import /container/api/user/** */
import KullaniciKontrolR from './container/api/user/KullaniciKontrolReducer';
import OtpAlR from './container/api/user/OtpAlReducer';
import OtpKontrolR from './container/api/user/OtpKontrolReducer';
import OturumAcR from './container/api/user/OturumAcReducer';
import OturumKapatR from './container/api/user/OturumKapatReducer';
import SifremiUnuttumR from './container/api/user/SifremiUnuttumReducer';
import SifreDegistirR from './container/api/user/SifreDegistirReducer';
import UiVersionKontrolR from './container/api/user/UiVersionKontrolReducer';
//#endregion
//#region import /container/api/veri/** */
import GrupSirketListeleR from './container/api/veri/GrupSirketListeleReducer';
import HaritadaAraR from './container/api/veri/HaritadaAraReducer';
import ProjeListeleR from './container/api/veri/ProjeListeleReducer';
import RaporUrlGetirR from './container/api/veri/RaporUrlGetirReducer';
import SorguInputlariR from './container/api/veri/SorguInputlariReducer';
import FaaliyetAlaniListesiR from './container/api/veri/FaaliyetAlaniListesiReducer';
//#endregion
//#region import /container/api/bilgi/** */
import AnasayfaUstBilgiR from './container/api/bilgi/AnasayfaUstBilgiReducer';
import FaaliyetAlaniUstBilgiR from './container/api/bilgi/FaaliyetAlaniUstBilgiReducer';
import GrupSirketDegerlemeUstBilgiR from './container/api/bilgi/GrupSirketDegerlemeUstBilgiReducer';
import GrupSirketiUstBilgiR from './container/api/bilgi/GrupSirketiUstBilgiReducer';
import KiraBilgiR from './container/api/bilgi/KiraBilgiReducer';
import KiraGenelBilgiR from './container/api/bilgi/KiraGenelBilgiReducer';
import MadenSahalariBilgiR from './container/api/bilgi/MadenSahalariBilgiReducer';
import MadenSahalariGenelBilgiR from './container/api/bilgi/MadenSahalariGenelBilgiReducer';
import OyakDegerlemeUstBilgiR from './container/api/bilgi/OyakDegerlemeUstBilgiReducer';
import OyakGmCiroBazliListeR from './container/api/bilgi/OyakGmCiroBazliListeReducer';
import OyakKiraBilgileriUstBilgiAkgDetayR from './container/api/bilgi/OyakKiraBilgileriUstBilgiAkgDetayReducer';
import OyakKiraBilgileriUstBilgiR from './container/api/bilgi/OyakKiraBilgileriUstBilgiReducer';
import OyakKiraBilgileriUstBilgiKvtDetayR from './container/api/bilgi/OyakKiraBilgileriUstBilgiKvtDetayReducer';
import OyakKiraBilgileriUstBilgiYkgDetayR from './container/api/bilgi/OyakKiraBilgileriUstBilgiYkgDetayReducer';
import OyakKiraTrGeneliKirayaVerilenTasinmazlarR from './container/api/bilgi/OyakKiraTrGeneliKirayaVerilenTasinmazlarReducer';
import OyakProjeToplamHakedisListeR from './container/api/bilgi/OyakProjeToplamHakedisListeReducer';
import SorgulamaSonuclariListeR from './container/api/bilgi/SorgulamaSonuclariReducer';
import TiklamaSonuclariR from './container/api/bilgi/TiklamaSonuclariReducer';
import UstBilgiIstatistikDetayR from './container/api/bilgi/UstBilgiIstatistikDetayReducer';
import YurtDisiTasinmazlariBilgiR from './container/api/bilgi/YurtDisiTasinmazlarBilgiReducer';
import YurtDisiTasinmazlariGenelBilgiR from './container/api/bilgi/YurtDisiTasinmazlarGenelBilgiReducer';
//#endregion
//#endregion
//#region import /container/page/** */
import DashboardR from './container/page/DashboardReducer';
import DegerlemeBilgileriR from './container/page/DegerlemeBilgileriReducer';
import EmlakVergileriR from './container/page/EmlakVergileriReducer';
import FaaliyetAlaniR from './container/page/FaaliyetAlaniReducer';
import FourOhFourR from './container/page/FourOhFourReducer';
import GayrimenkulAlanR from './container/page/GayrimenkulAlanReducer';
import GayrimenkulSayiR from './container/page/GayrimenkulSayiReducer';
import GayrimenkulToplamDegerR from './container/page/GayrimenkulToplamDegerReducer';
import GrupSirketiR from './container/page/GrupSirketiReducer';
import HaritaR from './container/page/HaritaReducer';
import KiraBilgileriR from './container/page/KiraBilgileriReducer';
import KisiselR from './container/page/KisiselReducer';
import LoginR from './container/page/LoginReducer';
import MadenSahalariR from './container/page/MadenSahalariReducer';
import OyakDegerlemeBilgileriR from './container/page/OyakDegerlemeBilgileriReducer';
import OyakGmCiroBazliR from './container/page/OyakGmCiroBazliReducer';
import OyakKiraBilgileriR from './container/page/OyakKiraBilgileriReducer';
import OyakKiraKirayaVerilenTasinmazlarR from './container/page/OyakKiraKirayaVerilenTasinmazlarReducer';
import OyakKiraTrGeneliAylikGelirDagilimiR from './container/page/OyakKiraTrGeneliAylikGelirDagilimiReducer';
import OyakKiraTrGeneliYillikGelirDagilimiR from './container/page/OyakKiraTrGeneliYillikGelirDagilimiReducer';
import OyakProjeAyBazliToplamHakedisR from './container/page/OyakProjeAyBazliToplamHakedisReducer';
import OyakProjeToplamHakedisR from './container/page/OyakProjeToplamHakedisReducer';
import OyakProjeYilBazliToplamHakedisR from './container/page/OyakProjeYilBazliToplamHakedisReducer';
import OyakR from './container/page/OyakReducer';
import ProjelerR from './container/page/ProjelerReducer';
import SorgulamaSonuclariR from './container/page/SorgulamaSonuclariReducer';
import SorgulaR from './container/page/SorgulaReducer';
import TasinmazBilgileriR from './container/page/TasinmazBilgileriReducer';
//#region import /models/** */
import {
  DefaultIKeyValPairAndInputStateModel as DIKVISM,
  DefaultInputDataStateModel as DIDSM,
  IInputDataStateModel as IIDSM,
  DefaultObjectState as DOSM,
  IKeyValPairAndInputStateModel as IKVISM,
  IObjectStateModel as IOSM,
} from '../models/StateModels';
import {
  pCore,
  pList,
  pKullaniciKontrol,
  pOtpAl,
  pOtpKontrol,
  pOturumAc,
  rKiraBilgi,
  rKiraGenelBilgi,
  rKullanici,
  rMadenSahalariBilgi,
  rMadenSahalariGenelBilgi,
  rOtp,
  rOyakDegerlemeUstBilgi,
  rOyakEmlakVergileri,
  rEmlakVergiUstbilgiDetay,
  rOyakGmCiroBazli,
  rOyakKiraBilgileriUstBilgi,
  rOyakProjeToplamHakedis,
  rIstatistikPopupSonucListesi,
  rIstatistikSonuc_3,
  rIstatistikSonuc_4,
  rProje,
  rSorguInputlari,
  rSorgulamaSonuclari,
  rUstBilgi,
  rYurtDisiTasinmazlariBilgi,
  rYurtDisiTasinmazlariGenelBilgi,
  rCore,
  pSifremiUnuttum,
  rOyakKiraBilgileriYillarWrapper,
  rFaaliyetAlaniListesi,
  pUiVersionKontrol,
  rUiVersionKontrolSonuc,
} from '../api/models/.catalog';
import { rGrupSirket } from '../api/models/rGrupSirket';
import { rHaritadaAra } from '../api/models/rHaritadaAra';
import { rOyakKiraBilgileriUstBilgiKvtDetay } from '../api/models/rOyakKiraBilgileriUstBilgiKvtDetay';
import { rOyakKiraBilgileriUstBilgiYkgDetay } from '../api/models/rOyakKiraBilgileriUstBilgiYkgDetay';
import { rOyakKiraBilgileriUstBilgiAkgDetay } from '../api/models/rOyakKiraBilgileriUstBilgiAkgDetay';
import { rGrupSirketDegerlemeUstBilgi } from '../api/models/rGrupSirketDegerlemeUstBilgi';
import pSifreDegistir from '../api/models/pSifreDegistir';
//#endregion

export interface IReducerStore {
  //#region page
  dashboardReducer: any;
  degerlemeBilgileriReducer: any;
  emlakVergileriReducer: any;
  faaliyetAlaniReducer: any;
  fourOhFourReducer: any;
  gayrimenkulAlanReducer: any;
  gayrimenkulSayiReducer: any;
  gayrimenkulToplamDegerReducer: any;
  grupSirketiReducer: any;
  haritaReducer: any;
  kiraBilgileriReducer: any;
  kisiselReducer: any;
  loginReducer: any;
  madenSahalariReducer: any;
  oyakDegerlemeBilgileriReducer: any;
  oyakGmCiroBazliReducer: any;
  oyakKiraBilgileriReducer: any;
  oyakKiraKirayaVerilenTasinmazlarReducer: any;
  oyakKiraTrGeneliAylikGelirDagilimiReducer: any;
  oyakKiraTrGeneliYillikGelirDagilimiReducer: any;
  oyakProjeAyBazliToplamHakedisReducer: any;
  oyakProjeToplamHakedisReducer: any;
  oyakProjeYilBazliToplamHakedisReducer: any;
  oyakReducer: any;
  projelerReducer: any;
  sorgulamaSonuclariReducer: any;
  sorgulaReducer: any;
  tasinmazBilgileriReducer: any;
  //#endregion
  //#region api
  //#region api/stat
  degerlemeToplamDegerReducer: any;
  gayrimenkulAlanApiReducer: any;
  gayrimenkulSayiApiReducer: any;
  gayrimenkulToplamDegerApiReducer: any;
  kullanimAmacliGayrimenkulAlanReducer: any;
  kullanimAmacliGayrimenkulSayiReducer: any;
  kullanimAmacliGayrimenkulToplamDegerReducer: any;
  oyakDegerlemeToplamDegerReducer: any;
  oyakKiraTrGeneliAylikGelirDagilimiListeleReducer: any;
  oyakKiraTrGeneliYillikGelirDagilimiListeleReducer: any;
  yatirimAmacliGayrimenkulAlanReducer: any;
  yatirimAmacliGayrimenkulSayiReducer: any;
  yatirimAmacliGayrimenkulToplamDegerReducer: any;
  oyakEmlakVergileriReducer: any;
  oyakEmlakVergileriDetayToplamDegerReducer: any;
  //#endregion
  //#region api/user
  kullaniciKontrolReducer: any;
  otpAlReducer: any;
  otpKontrolReducer: any;
  oturumAcReducer: any;
  oturumKapatReducer: any;
  sifremiUnuttumReducer: any;
  sifreDegistirReducer: any;
  uiVersionKontrolReducer: any;
  //#endregion
  //#region api/veri
  grupSirketListeleReducer: any;
  faaliyetAlaniListesiReducer: any;
  haritadaAraReducer: any;
  projeListeleReducer: any;
  sorguInputlariReducer: any;
  raporUrlGetirReducer: any;
  //#endregion
  //#region api/bilgi
  anasayfaUstBilgiReducer: any;
  faaliyetAlaniUstBilgiReducer: any;
  grupSirketDegerlemeUstBilgiReducer: any;
  grupSirketiUstBilgiReducer: any;
  kiraBilgiReducer: any;
  kiraGenelBilgiReducer: any;
  madenSahalariBilgiReducer: any;
  madenSahalariGenelBilgiReducer: any;
  oyakDegerlemeUstBilgiReducer: any;
  oyakGmCiroBazliListeReducer: any;
  oyakKiraBilgileriUstBilgiAkgDetayReducer: any;
  oyakKiraBilgileriUstBilgiReducer: any;
  oyakKiraBilgileriUstBilgiKvtDetayReducer: any;
  oyakKiraBilgileriUstBilgiYkgDetayReducer: any;
  oyakKiraTrGeneliKirayaVerilenTasinmazlarReducer: any;
  oyakProjeToplamHakedisListeReducer: any;
  sorgulamaSonuclariListeReducer: any;
  ustBilgiIstatistikDetayReducer: any;
  tiklamaSonuclariReducer: any;
  yurtDisiTasinmazlariBilgiReducer: any;
  yurtDisiTasinmazlariGenelBilgiReducer: any;
  //#endregion
  //#endregion
  router?: any;
}

export interface IReducers extends IReducerStore {
  //#region Page
  dashboardReducer: IOSM;
  degerlemeBilgileriReducer: IOSM;
  emlakVergileriReducer: IOSM;
  faaliyetAlaniReducer: IOSM;
  fourOhFourReducer: IOSM;
  gayrimenkulAlanReducer: IOSM;
  gayrimenkulSayiReducer: IOSM;
  gayrimenkulToplamDegerReducer: IOSM;
  grupSirketiReducer: IOSM;
  haritaReducer: IOSM;
  kiraBilgileriReducer: IOSM;
  kisiselReducer: IOSM;
  loginReducer: IOSM;
  madenSahalariReducer: IOSM;
  oyakGmCiroBazliReducer: IOSM;
  sorgulamaSonuclariReducer: IOSM;
  oyakProjeToplamHakedisReducer: IOSM;
  oyakProjeYilBazliToplamHakedisReducer: IOSM;
  oyakProjeAyBazliToplamHakedisReducer: IOSM;
  oyakKiraKirayaVerilenTasinmazlarReducer: IOSM;
  oyakReducer: IOSM;
  projelerReducer: IOSM;
  sorgulaReducer: IOSM;
  tasinmazBilgileriReducer: IOSM;
  oyakKiraBilgileriReducer: IOSM;
  oyakDegerlemeBilgileriReducer: IOSM;
  oyakKiraTrGeneliYillikGelirDagilimiReducer: IOSM;
  oyakKiraTrGeneliAylikGelirDagilimiReducer: IOSM;
  //#endregion
  //#region Api
  oturumAcReducer: IIDSM<pOturumAc, rKullanici>;
  oturumKapatReducer: IIDSM<pCore, rCore>;
  kullaniciKontrolReducer: IIDSM<pKullaniciKontrol, boolean>;
  otpAlReducer: IIDSM<pOtpAl, rOtp>;
  otpKontrolReducer: IIDSM<pOtpKontrol, rOtp>;
  sifremiUnuttumReducer: IIDSM<pSifremiUnuttum, rCore>;
  sifreDegistirReducer: IIDSM<pSifreDegistir, rCore>;
  anasayfaUstBilgiReducer: IIDSM<pList, rUstBilgi>;
  faaliyetAlaniUstBilgiReducer: IIDSM<pList, rUstBilgi>;
  grupSirketiUstBilgiReducer: IIDSM<pList, rUstBilgi>;
  kiraBilgiReducer: IIDSM<pList, rKiraBilgi>;
  kiraGenelBilgiReducer: IIDSM<pList, rKiraGenelBilgi>;
  yurtDisiTasinmazlariGenelBilgiReducer: IIDSM<pList, rYurtDisiTasinmazlariGenelBilgi>;
  oyakKiraTrGeneliKirayaVerilenTasinmazlarReducer: IKVISM<pList>;
  yurtDisiTasinmazlariBilgiReducer: IIDSM<pList, rYurtDisiTasinmazlariBilgi>;
  madenSahalariBilgiReducer: IIDSM<pList, rMadenSahalariBilgi>;
  oyakGmCiroBazliListeReducer: IIDSM<pList, rOyakGmCiroBazli>;
  sorgulamaSonuclariListeReducer: IIDSM<pList, rSorgulamaSonuclari[]>;
  tiklamaSonuclariReducer: IIDSM<pList, rSorgulamaSonuclari[]>;
  oyakProjeToplamHakedisListeReducer: IIDSM<pList, rOyakProjeToplamHakedis>;
  madenSahalariGenelBilgiReducer: IIDSM<pList, rMadenSahalariGenelBilgi>;
  gayrimenkulAlanApiReducer: IKVISM<pList>;
  gayrimenkulSayiApiReducer: IKVISM<pList>;
  gayrimenkulToplamDegerApiReducer: IKVISM<pList>;
  degerlemeToplamDegerReducer: IIDSM<pList, rIstatistikSonuc_3>;
  kullanimAmacliGayrimenkulAlanReducer: IKVISM<pList>;
  kullanimAmacliGayrimenkulSayiReducer: IKVISM<pList>;
  kullanimAmacliGayrimenkulToplamDegerReducer: IKVISM<pList>;
  yatirimAmacliGayrimenkulAlanReducer: IKVISM<pList>;
  yatirimAmacliGayrimenkulSayiReducer: IKVISM<pList>;
  yatirimAmacliGayrimenkulToplamDegerReducer: IKVISM<pList>;
  sorguInputlariReducer: IIDSM<pList, rSorguInputlari>;
  grupSirketListeleReducer: IIDSM<pList, rGrupSirket[]>;
  faaliyetAlaniListesiReducer: IIDSM<pList, rFaaliyetAlaniListesi[]>;
  haritadaAraReducer: IIDSM<pList, rHaritadaAra[]>;
  ustBilgiIstatistikDetayReducer: IIDSM<pList, rIstatistikPopupSonucListesi>;
  oyakKiraBilgileriUstBilgiReducer: IIDSM<pList, rOyakKiraBilgileriUstBilgi>;
  oyakKiraBilgileriUstBilgiKvtDetayReducer: IIDSM<pList, rOyakKiraBilgileriUstBilgiKvtDetay[]>;
  oyakKiraBilgileriUstBilgiYkgDetayReducer: IIDSM<pList, rOyakKiraBilgileriUstBilgiYkgDetay[]>;
  oyakKiraBilgileriUstBilgiAkgDetayReducer: IIDSM<pList, rOyakKiraBilgileriUstBilgiAkgDetay[]>;
  projeListeleReducer: IIDSM<pList, rProje[]>;
  grupSirketDegerlemeUstBilgiReducer: IIDSM<pList, rGrupSirketDegerlemeUstBilgi>;
  oyakDegerlemeToplamDegerReducer: IIDSM<pList, rIstatistikSonuc_4>;
  oyakDegerlemeUstBilgiReducer: IIDSM<pList, rOyakDegerlemeUstBilgi>;
  oyakEmlakVergileriReducer: IIDSM<pList, rOyakEmlakVergileri>;
  oyakEmlakVergileriDetayToplamDegerReducer: IIDSM<pList, rEmlakVergiUstbilgiDetay>;
  oyakKiraTrGeneliYillikGelirDagilimiListeleReducer: IIDSM<pList, rOyakKiraBilgileriYillarWrapper>;
  oyakKiraTrGeneliAylikGelirDagilimiListeleReducer: IIDSM<pList, rOyakKiraBilgileriYillarWrapper>;
  raporUrlGetirReducer: IIDSM<pList, string>;
  uiVersionKontrolReducer: IIDSM<pUiVersionKontrol, rUiVersionKontrolSonuc>;
  //#endregion
  router?: RouterState;
}

const _Reducer: IReducerStore = {
  //#region Page
  dashboardReducer: DashboardR,
  degerlemeBilgileriReducer: DegerlemeBilgileriR,
  emlakVergileriReducer: EmlakVergileriR,
  faaliyetAlaniReducer: FaaliyetAlaniR,
  fourOhFourReducer: FourOhFourR,
  gayrimenkulAlanReducer: GayrimenkulAlanR,
  gayrimenkulSayiReducer: GayrimenkulSayiR,
  gayrimenkulToplamDegerReducer: GayrimenkulToplamDegerR,
  grupSirketiReducer: GrupSirketiR,
  haritaReducer: HaritaR,
  kiraBilgileriReducer: KiraBilgileriR,
  kisiselReducer: KisiselR,
  loginReducer: LoginR,
  madenSahalariReducer: MadenSahalariR,
  oyakGmCiroBazliReducer: OyakGmCiroBazliR,
  sorgulamaSonuclariReducer: SorgulamaSonuclariR,
  oyakProjeToplamHakedisReducer: OyakProjeToplamHakedisR,
  oyakProjeYilBazliToplamHakedisReducer: OyakProjeYilBazliToplamHakedisR,
  oyakProjeAyBazliToplamHakedisReducer: OyakProjeAyBazliToplamHakedisR,
  oyakReducer: OyakR,
  projelerReducer: ProjelerR,
  sorgulaReducer: SorgulaR,
  tasinmazBilgileriReducer: TasinmazBilgileriR,
  oyakKiraBilgileriReducer: OyakKiraBilgileriR,
  oyakKiraKirayaVerilenTasinmazlarReducer: OyakKiraKirayaVerilenTasinmazlarR,
  oyakDegerlemeBilgileriReducer: OyakDegerlemeBilgileriR,
  oyakKiraTrGeneliYillikGelirDagilimiReducer: OyakKiraTrGeneliYillikGelirDagilimiR,
  oyakKiraTrGeneliAylikGelirDagilimiReducer: OyakKiraTrGeneliAylikGelirDagilimiR,
  oyakKiraTrGeneliYillikGelirDagilimiListeleReducer: OyakKiraTrGeneliYillikGelirDagilimiListeleR,
  oyakKiraTrGeneliAylikGelirDagilimiListeleReducer: OyakKiraTrGeneliAylikGelirDagilimiListeleR,
  //#endregion
  //#region Api
  oturumAcReducer: OturumAcR,
  oturumKapatReducer: OturumKapatR,
  kullaniciKontrolReducer: KullaniciKontrolR,
  otpAlReducer: OtpAlR,
  otpKontrolReducer: OtpKontrolR,
  sifremiUnuttumReducer: SifremiUnuttumR,
  sifreDegistirReducer: SifreDegistirR,
  anasayfaUstBilgiReducer: AnasayfaUstBilgiR,
  faaliyetAlaniUstBilgiReducer: FaaliyetAlaniUstBilgiR,
  grupSirketiUstBilgiReducer: GrupSirketiUstBilgiR,
  kiraBilgiReducer: KiraBilgiR,
  kiraGenelBilgiReducer: KiraGenelBilgiR,
  yurtDisiTasinmazlariGenelBilgiReducer: YurtDisiTasinmazlariGenelBilgiR,
  yurtDisiTasinmazlariBilgiReducer: YurtDisiTasinmazlariBilgiR,
  madenSahalariBilgiReducer: MadenSahalariBilgiR,
  oyakGmCiroBazliListeReducer: OyakGmCiroBazliListeR,
  sorgulamaSonuclariListeReducer: SorgulamaSonuclariListeR,
  tiklamaSonuclariReducer: TiklamaSonuclariR,
  oyakProjeToplamHakedisListeReducer: OyakProjeToplamHakedisListeR,
  madenSahalariGenelBilgiReducer: MadenSahalariGenelBilgiR,
  gayrimenkulAlanApiReducer: GayrimenkulAlanApiR,
  gayrimenkulSayiApiReducer: GayrimenkulSayiApiR,
  gayrimenkulToplamDegerApiReducer: GayrimenkulToplamDegerApiR,
  degerlemeToplamDegerReducer: DegerlemeToplamDegerR,
  kullanimAmacliGayrimenkulAlanReducer: KullanimAmacliGayrimenkulAlanR,
  kullanimAmacliGayrimenkulSayiReducer: KullanimAmacliGayrimenkulSayiR,
  kullanimAmacliGayrimenkulToplamDegerReducer: KullanimAmacliGayrimenkulToplamDegerR,
  yatirimAmacliGayrimenkulAlanReducer: YatirimAmacliGayrimenkulAlanR,
  yatirimAmacliGayrimenkulSayiReducer: YatirimAmacliGayrimenkulSayiR,
  yatirimAmacliGayrimenkulToplamDegerReducer: YatirimAmacliGayrimenkulToplamDegerR,
  sorguInputlariReducer: SorguInputlariR,
  grupSirketListeleReducer: GrupSirketListeleR,
  faaliyetAlaniListesiReducer: FaaliyetAlaniListesiR,
  haritadaAraReducer: HaritadaAraR,
  ustBilgiIstatistikDetayReducer: UstBilgiIstatistikDetayR,
  oyakKiraBilgileriUstBilgiReducer: OyakKiraBilgileriUstBilgiR,
  oyakKiraBilgileriUstBilgiKvtDetayReducer: OyakKiraBilgileriUstBilgiKvtDetayR,
  oyakKiraBilgileriUstBilgiYkgDetayReducer: OyakKiraBilgileriUstBilgiYkgDetayR,
  oyakKiraBilgileriUstBilgiAkgDetayReducer: OyakKiraBilgileriUstBilgiAkgDetayR,
  projeListeleReducer: ProjeListeleR,
  grupSirketDegerlemeUstBilgiReducer: GrupSirketDegerlemeUstBilgiR,
  oyakKiraTrGeneliKirayaVerilenTasinmazlarReducer: OyakKiraTrGeneliKirayaVerilenTasinmazlarR,
  oyakDegerlemeToplamDegerReducer: OyakDegerlemeToplamDegerR,
  oyakDegerlemeUstBilgiReducer: OyakDegerlemeUstBilgiR,
  oyakEmlakVergileriReducer: OyakEmlakVergileriR,
  oyakEmlakVergileriDetayToplamDegerReducer: OyakEmlakVergileriDetayToplamDegerR,
  raporUrlGetirReducer: RaporUrlGetirR,
  uiVersionKontrolReducer: UiVersionKontrolR,
  //#endregion
  router: routerReducer,
};

export const Reducer = combineReducers(_Reducer);

export const InitialState: IReducers = {
  //#region Page
  dashboardReducer: DOSM,
  degerlemeBilgileriReducer: DOSM,
  emlakVergileriReducer: DOSM,
  faaliyetAlaniReducer: DOSM,
  fourOhFourReducer: DOSM,
  gayrimenkulAlanReducer: DOSM,
  gayrimenkulSayiReducer: DOSM,
  gayrimenkulToplamDegerReducer: DOSM,
  grupSirketiReducer: DOSM,
  haritaReducer: DOSM,
  kiraBilgileriReducer: DOSM,
  kisiselReducer: DOSM,
  loginReducer: DOSM,
  madenSahalariReducer: DOSM,
  oyakGmCiroBazliReducer: DOSM,
  sorgulamaSonuclariReducer: DOSM,
  oyakProjeToplamHakedisReducer: DOSM,
  oyakProjeYilBazliToplamHakedisReducer: DOSM,
  oyakProjeAyBazliToplamHakedisReducer: DOSM,
  oyakReducer: DOSM,
  projelerReducer: DOSM,
  sorgulaReducer: DOSM,
  tasinmazBilgileriReducer: DOSM,
  oyakKiraBilgileriReducer: DOSM,
  oyakKiraKirayaVerilenTasinmazlarReducer: DOSM,
  oyakDegerlemeBilgileriReducer: DOSM,
  oyakKiraTrGeneliYillikGelirDagilimiReducer: DOSM,
  oyakKiraTrGeneliAylikGelirDagilimiReducer: DOSM,
  //#endregion
  //#region Api
  oturumAcReducer: DIDSM<pOturumAc, rKullanici>(),
  oturumKapatReducer: DIDSM<pCore, rCore>(),
  kullaniciKontrolReducer: DIDSM<pKullaniciKontrol, boolean>(),
  otpAlReducer: DIDSM<pOtpAl, rOtp>(),
  otpKontrolReducer: DIDSM<pOtpKontrol, rOtp>(),
  sifremiUnuttumReducer: DIDSM<pSifremiUnuttum, rCore>(),
  sifreDegistirReducer: DIDSM<pSifreDegistir, rCore>(),
  anasayfaUstBilgiReducer: DIDSM<pList, rUstBilgi>(),
  faaliyetAlaniUstBilgiReducer: DIDSM<pList, rUstBilgi>(),
  grupSirketiUstBilgiReducer: DIDSM<pList, rUstBilgi>(),
  kiraBilgiReducer: DIDSM<pList, rKiraBilgi>(),
  kiraGenelBilgiReducer: DIDSM<pList, rKiraGenelBilgi>(),
  yurtDisiTasinmazlariGenelBilgiReducer: DIDSM<pList, rYurtDisiTasinmazlariGenelBilgi>(),
  yurtDisiTasinmazlariBilgiReducer: DIDSM<pList, rYurtDisiTasinmazlariBilgi>(),
  madenSahalariBilgiReducer: DIDSM<pList, rMadenSahalariBilgi>(),
  oyakGmCiroBazliListeReducer: DIDSM<pList, rOyakGmCiroBazli>(),
  sorgulamaSonuclariListeReducer: DIDSM<pList, rSorgulamaSonuclari[]>(),
  tiklamaSonuclariReducer: DIDSM<pList, rSorgulamaSonuclari[]>(),
  oyakProjeToplamHakedisListeReducer: DIDSM<pList, rOyakProjeToplamHakedis>(),
  madenSahalariGenelBilgiReducer: DIDSM<pList, rMadenSahalariGenelBilgi>(),
  oyakKiraTrGeneliKirayaVerilenTasinmazlarReducer: DIKVISM<pList>(),
  gayrimenkulAlanApiReducer: DIKVISM<pList>(),
  gayrimenkulSayiApiReducer: DIKVISM<pList>(),
  gayrimenkulToplamDegerApiReducer: DIKVISM<pList>(),
  degerlemeToplamDegerReducer: DIDSM<pList, rIstatistikSonuc_3>(),
  kullanimAmacliGayrimenkulAlanReducer: DIKVISM<pList>(),
  kullanimAmacliGayrimenkulSayiReducer: DIKVISM<pList>(),
  kullanimAmacliGayrimenkulToplamDegerReducer: DIKVISM<pList>(),
  yatirimAmacliGayrimenkulAlanReducer: DIKVISM<pList>(),
  yatirimAmacliGayrimenkulSayiReducer: DIKVISM<pList>(),
  yatirimAmacliGayrimenkulToplamDegerReducer: DIKVISM<pList>(),
  sorguInputlariReducer: DIDSM<pList, rSorguInputlari>(),
  grupSirketListeleReducer: DIDSM<pList, rGrupSirket[]>(),
  faaliyetAlaniListesiReducer: DIDSM<pList, rFaaliyetAlaniListesi[]>(),
  haritadaAraReducer: DIDSM<pList, rHaritadaAra[]>(),
  ustBilgiIstatistikDetayReducer: DIDSM<pList, rIstatistikPopupSonucListesi>(),
  oyakKiraBilgileriUstBilgiReducer: DIDSM<pList, rOyakKiraBilgileriUstBilgi>(),
  oyakKiraBilgileriUstBilgiKvtDetayReducer: DIDSM<pList, rOyakKiraBilgileriUstBilgiKvtDetay[]>(),
  oyakKiraBilgileriUstBilgiYkgDetayReducer: DIDSM<pList, rOyakKiraBilgileriUstBilgiYkgDetay[]>(),
  oyakKiraBilgileriUstBilgiAkgDetayReducer: DIDSM<pList, rOyakKiraBilgileriUstBilgiAkgDetay[]>(),
  projeListeleReducer: DIDSM<pList, rProje[]>(),
  grupSirketDegerlemeUstBilgiReducer: DIDSM<pList, rGrupSirketDegerlemeUstBilgi>(),
  oyakDegerlemeToplamDegerReducer: DIDSM<pList, rIstatistikSonuc_4>(),
  oyakDegerlemeUstBilgiReducer: DIDSM<pList, rOyakDegerlemeUstBilgi>(),
  oyakEmlakVergileriReducer: DIDSM<pList, rOyakEmlakVergileri>(),
  oyakEmlakVergileriDetayToplamDegerReducer: DIDSM<pList, rEmlakVergiUstbilgiDetay>(),
  oyakKiraTrGeneliYillikGelirDagilimiListeleReducer: DIDSM<
    pList,
    rOyakKiraBilgileriYillarWrapper
  >(),
  oyakKiraTrGeneliAylikGelirDagilimiListeleReducer: DIDSM<pList, rOyakKiraBilgileriYillarWrapper>(),
  raporUrlGetirReducer: DIDSM<pList, string>(),
  uiVersionKontrolReducer: DIDSM<pUiVersionKontrol, rUiVersionKontrolSonuc>(),
  //#endregion
};
